<script lang="ts">
    import { nextTick } from 'vue'
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import VuePageQueries from "@Organizations/Users/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/Components/ValidationError.vue";

    @Component({
        watch: {
            isAuthenticated: 'isAuthenticatedChanged'
        }
    })
    export default class SigninPage extends mixins(PageBase, PageStatus, VuePageQueries, VuePageCommands) {
        inputEmail = '';
        inputPassword = '';
        inputSignedInAsDifferentUser = false;
        result = null;

        get inputEmailRef(): HTMLInputElement { return this.$refs.inputEmailRef as HTMLInputElement }
        get inputPasswordRef(): HTMLInputElement { return this.$refs.inputPasswordRef as HTMLInputElement }

        get userSessionDetails() { return this.model?.UserSessionDetails; }
        get email() { return this.userSessionDetails?.Email; }

        get isAuthenticated() { return this.result?.IsAuthenticated || false }
        get accessUrl() { return this.result?.AccessUrl || null }

        get signInFormVisible() { return this.userSessionDetails && !this.isAuthenticated && (!this.email || this.inputSignedInAsDifferentUser) }
        get signedInAlertVisible() { return this.email && !this.inputSignedInAsDifferentUser }

        get signinCommandEnabled() { return this.statusInitial || this.statusInvalid }
        get unableToAuthenticate() { return this.result && !this.result.IsAuthenticated }

        mounted() {
            this.setTitle('Sign in to TransparentChoice');
            this.runCurrentUserQueryV1(false, false, false);
        }

        handleSignInCommandV1(evt) {
            if (!this.inputEmail) {
                this.inputEmailRef.focus()
            }
            else if (!this.inputPassword) {
                this.inputPasswordRef.focus()
            }
            else {
                this.result = null;
                this.$clearValidationErrors();
                this.setStatusInvoking();
                this.invokeSignInCommandV1(this.inputEmail, this.inputPassword, this.$route.query.returnUrl);
            }
        }

        succeedSignInCommandV1(status) {
            this.result = status.Result;
            this.setStatusSucceed();
        }

        invalidSignInCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        handleTryAgain() {
            this.result = null;
            this.$clearValidationErrors();
            this.setStatusInitial();
        }

        //@Watch('isAuthenticated')
        isAuthenticatedChanged(isAuthenticated) {
            if (isAuthenticated) {
                this.navigateTo(this.accessUrl);
            }
        }
    }
</script>

<template>
    <div>
        <div v-if="signInFormVisible" style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <div v-show="statusInitial || statusInvoking || statusInvalid">
                <h3 class="fg-color-blue">Sign in to TransparentChoice</h3>
                <br />

                <div class="form-group">
                    <label>Email:</label>
                    <input v-model="inputEmail" ref="inputEmailRef" type="email" class="form-control" placeholder="Email address" @keyup.enter="handleSignInCommandV1" autofocus>
                    <ValidationError context="Email" :errors="validationErrors"></ValidationError>
                </div>

                <div class="form-group">
                    <label>Password:</label>
                    <input v-model="inputPassword" ref="inputPasswordRef" type="password" class="form-control" placeholder="Password" @keyup.enter="handleSignInCommandV1">

                    <div class="text-right">
                        <a href="/#/organizations/users/requestresetpassword" class="text-dark">Forgot password?</a>
                    </div>
                </div>

                <div>
                    <div class="error"><br /></div>
                </div>

                <button v-show="signinCommandEnabled" @click="handleSignInCommandV1" @keyup.enter="handleSignInCommandV1" class="btn btn-lg btn-primary btn-block">Sign in</button>
                <button v-show="statusInvoking" class="btn btn-lg btn-primary btn-block" disabled>Signing in...</button>
                <br />

                <!--<span>
                    <span>Don't have an account?</span>
                    <a href="/#/organizations/users/requestaccount">Request access</a>
                </span>-->
                <hr /><br />
                <a href="/#/organizations/users/sso" class="btn btn-secondary btn-lg btn-block">Sign in with SSO</a>
            </div>

            <div v-show="unableToAuthenticate">
                <h3 class="fg-color-blue">Unable to sign-in</h3>
                <br />

                <p>There can be many reasons for this, eg.:</p>
                <ul>
                    <li>email and password mismatch</li>
                    <li>typo or caps lock is enabled</li>
                    <li>account does not exist</li>
                    <li>account is locked (eg. due to inactivity)</li>
                    <li>your access request is pending or was rejected</li>
                </ul>
                <p>
                    Please check your email for any alerts. You can also request reset your password
                    <a href="/#/organizations/users/requestresetpassword">here</a>.
                </p>
                <br />

                <button @click="handleTryAgain" class="btn btn-lg btn-primary btn-block">Try again</button>
            </div>
        </div>

        <div v-if="signedInAlertVisible" style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <h3 class="fg-color-blue">You are already signed in as {{email}}</h3>
            <br />
            <button @click="inputSignedInAsDifferentUser=true" class="btn btn-lg btn-primary btn-block">Sign in as a different user</button>
            <a href="/" class="btn btn-lg btn-secondary btn-block">Go to my account</a>
        </div>
    </div>
</template>